// import useAbilitiesHelper from "@helpers/AbilitiesHelper"

export const MENU_NON_RAW_MATS = (ability) => {
  // const [isUserAllowed] = useAbilitiesHelper(ability);
  return [
    { name: 'Purchase Contract', url: '/nonrawmats/purchasecontracts', icon: 'bi bi-cart4', hasSubMenu: false, exactMenu: true },
    {
      name: 'Maintenance', url: '/nonrawmats/maintenance', icon: 'bi bi-gear', hasSubMenu: true,
      submenu: [
        // { name: 'Approvers', url: `/nonrawmats/maintenance/approvers`, permissions: ['pur_maint_po_approvers'], },
        // { name: 'ATL Rules', url: `/nonrawmats/maintenance/atlrules`, permissions: ['pur_maint_po_list'], },
        // { name: 'List', url: `/nonrawmats/maintenance/lists`, permissions: ['pur_maint_po_list'], },
        // { name: 'Mail - Approvers', url: `/nonrawmats/maintenance/mailapprovers`, permissions: ['pur_maint_po_m_approver'], },
        // { name: "Mail - Follow-Up", url: `/nonrawmats/maintenance/mailreminder`, permissions: ['pur_maint_po_m_followup'], },
        // { name: "Mail - Supplier", url: `/nonrawmats/maintenance/mailsupplier`, permissions: ['pur_maint_po_m_supplier'], },
        // { name: "Settings", url: `/nonrawmats/maintenance/mailsupplier`, permissions: ['pur_maint_po_m_supplier'], },
        { name: "Payment Terms - Non Raw/Job Order ", url: `/nonrawmats/maintenance/paymenttermsnonraw`, permissions: ['pur_maint_po_m_supplier'], },
        { name: "Suppliers - for Non-Raw/Job Order ", url: `/nonrawmats/maintenance/suppliersnonraw`, permissions: ['pur_maint_po_m_supplier'], },
      ]
    },
  ]
}